import { render, staticRenderFns } from "./ModelBanner.vue?vue&type=template&id=57c7661e&scoped=true"
import script from "./ModelBanner.vue?vue&type=script&lang=ts"
export * from "./ModelBanner.vue?vue&type=script&lang=ts"
import style0 from "./ModelBanner.vue?vue&type=style&index=0&id=57c7661e&prod&lang=scss"
import style1 from "./ModelBanner.vue?vue&type=style&index=1&id=57c7661e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7661e",
  null
  
)

export default component.exports